var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "duplicate 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lineal-Blue"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 5.625H5C4.17125 5.625 3.37625 5.95437 2.79 6.54C2.20438 7.12625 1.875 7.92125 1.875 8.75V15C1.875 15.8287 2.20438 16.6237 2.79 17.21C3.37625 17.7956 4.17125 18.125 5 18.125H11.25C12.0787 18.125 12.8737 17.7956 13.46 17.21C14.0456 16.6237 14.375 15.8287 14.375 15V14.375H15C15.8287 14.375 16.6237 14.0456 17.21 13.46C17.7956 12.8737 18.125 12.0787 18.125 11.25C18.125 9.38938 18.125 6.86062 18.125 5C18.125 4.17125 17.7956 3.37625 17.21 2.79C16.6237 2.20438 15.8287 1.875 15 1.875C13.1394 1.875 10.6106 1.875 8.75 1.875C7.92125 1.875 7.12625 2.20438 6.54 2.79C5.95437 3.37625 5.625 4.17125 5.625 5V5.625ZM13.125 8.75V15C13.125 15.4975 12.9275 15.9744 12.5756 16.3256C12.2244 16.6775 11.7475 16.875 11.25 16.875C9.38938 16.875 6.86062 16.875 5 16.875C4.5025 16.875 4.02562 16.6775 3.67438 16.3256C3.3225 15.9744 3.125 15.4975 3.125 15C3.125 13.1394 3.125 10.6106 3.125 8.75C3.125 8.2525 3.3225 7.77562 3.67438 7.42437C4.02562 7.0725 4.5025 6.875 5 6.875H11.25C11.7475 6.875 12.2244 7.0725 12.5756 7.42437C12.9275 7.77562 13.125 8.2525 13.125 8.75ZM14.375 13.125H15C15.4975 13.125 15.9744 12.9275 16.3256 12.5756C16.6775 12.2244 16.875 11.7475 16.875 11.25C16.875 9.38938 16.875 6.86062 16.875 5C16.875 4.5025 16.6775 4.02562 16.3256 3.67438C15.9744 3.3225 15.4975 3.125 15 3.125C13.1394 3.125 10.6106 3.125 8.75 3.125C8.2525 3.125 7.77562 3.3225 7.42437 3.67438C7.0725 4.02562 6.875 4.5025 6.875 5V5.625H11.25C12.0787 5.625 12.8737 5.95437 13.46 6.54C14.0456 7.12625 14.375 7.92125 14.375 8.75V13.125Z",
    fill: "url(#paint0_linear_1024_12022)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1024_12022",
    x1: 1.875,
    y1: 10,
    x2: 18.125,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04AEED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.eb067dffe1f29c071d37c20e537aad0f.svg";
export { ForwardRef as ReactComponent };